var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { RenderPacketTicket as RenderPacketTicket } from '../../../components/Ticket/RenderPacketTicket';
var PacketTicketPapel = /** @class */ (function (_super) {
    __extends(PacketTicketPapel, _super);
    function PacketTicketPapel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PacketTicketPapel.prototype.componentDidMount = function () {
        this.props.store.operationLines.read();
    };
    PacketTicketPapel.prototype.render = function () {
        var item = {};
        if (this.props.location && this.props.location.state) { // El item viene por el push
            // console.log('packetTicketPapel: ', this.props.location.state)
            // packetTickets.push(this.props.location.state)
            item = this.props.location.state;
        }
        else { // el dato viene por props
            item = this.props.item;
        }
        var showScan = this.props.showScan;
        // console.log('PacketTicketPapel - render() - packetTickets', packetTickets)
        return (React.createElement(RenderPacketTicket, { onRefund: this.props.onRefunded, item: item, operationline: this.props.store.operationLines.findOperationlineById(item.operationLine_id), key: item.numero }));
    };
    PacketTicketPapel = __decorate([
        inject('store'),
        observer
    ], PacketTicketPapel);
    return PacketTicketPapel;
}(Component));
export default PacketTicketPapel;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/components/PacketTicketPapel.tsx
// module id = 1152
// module chunks = 0